var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShield({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.85194 1.125C7.31021 3.2985 3.18848 3.43023 3.18848 3.43023V9.22623C3.18848 12.7829 9.85194 16.875 9.85194 16.875C9.85194 16.875 16.5154 12.7829 16.5154 9.22623V3.43023C16.5154 3.43023 12.3937 3.2985 9.85194 1.125ZM8.21727 7.981L9.40431 8.67117L11.8085 7.27068L8.27244 5.21192C8.21894 5.18169 8.15207 5.19849 8.1203 5.25222C8.11027 5.26901 8.10526 5.28917 8.10526 5.30932V7.78621C8.10526 7.86681 8.14705 7.9407 8.21727 7.981ZM8.10534 10.1036C8.10534 10.023 8.14714 9.94911 8.21736 9.90881L12.275 7.54778V10.285C12.2734 10.3253 12.2516 10.3622 12.2165 10.3824L8.27253 12.6779C8.21903 12.7081 8.15048 12.6913 8.12039 12.6376C8.11036 12.6208 8.10534 12.6006 8.10534 12.5805L8.10534 10.1036Z",
    fill: "#0089CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.65559e1fb2d915b32c12d9bb5b0ce1d1.svg";
export { ForwardRef as ReactComponent };